<template>
	<router-link :to="{ name: 'TriggerEditor', query: $route.query }" v-slot="{ isExactActive, navigate, href }" custom>
		<a :href="href" @click="(e) => navigateAndFocus(e, navigate)">
			<TriggerBox :title="title" :is-selected="isExactActive" />
		</a>
	</router-link>
</template>

<script>
import { mapActions } from 'vuex';

import TriggerBox from './TriggerBox.vue';
import { setFocusedElement } from '@/store/modules/flowTree/actions';
import { closeSideBar } from '@/store/modules/selectedNode/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'FlowTreeTriggerSection',
	components: { TriggerBox },
	props: {
		title: { type: String },
		triggerType: { type: String },
	},
	methods: {
		...mapActions([closeSideBar.fullPath]),
		...mapActionsShorthand({ setFocusedElement }),
		navigateAndFocus(e, navigate) {
			if (this.$route.name === 'TriggerEditor') {
				this[closeSideBar.fullPath]();
				e.stopPropagation();
				e.preventDefault();
				return;
			}
			// navigate is the default func exposed by the RouterLink component, because we want after navigating to focus on the clicked element
			navigate(e);
			this.$nextTick(() => {
				this.setFocusedElement(this.triggerType);
			});
		},
	},
};
</script>
<style lang="scss" scoped>
a {
	text-decoration: none;
}
</style>
